// Interactive pieces of the guide theme: savings calculator, sample checklist and scroll reveal.
// `tm-js` is added to <html> by theme.liquid, so content stays visible when JS is unavailable.

const euro = new Intl.NumberFormat('it-IT', { maximumFractionDigits: 0 });

// Sums the low and high savings estimates of the checked rows.
class TmCalculator extends HTMLElement {
  connectedCallback() {
    this.inputs = [...this.querySelectorAll('input[type="checkbox"]')];
    this.low = this.querySelector('[data-out="low"]');
    this.high = this.querySelector('[data-out="high"]');
    this.count = this.querySelector('[data-out="count"]');
    this.addEventListener('change', () => this.update());
    this.update();
  }

  update() {
    let low = 0;
    let high = 0;
    let picked = 0;

    for (const input of this.inputs) {
      if (!input.checked) continue;
      picked += 1;
      low += Number(input.dataset.low) || 0;
      high += Number(input.dataset.high) || 0;
    }

    if (this.low) this.low.textContent = euro.format(low);
    if (this.high) this.high.textContent = euro.format(high);
    if (this.count) this.count.textContent = String(picked);
  }
}

// Tracks how many checklist items are ticked and fills a progress bar.
class TmChecklist extends HTMLElement {
  connectedCallback() {
    this.inputs = [...this.querySelectorAll('input[type="checkbox"]')];
    this.bar = this.querySelector('[data-bar]');
    this.label = this.querySelector('[data-label]');
    this.addEventListener('change', () => this.update());
    this.update();
  }

  update() {
    const done = this.inputs.filter((input) => input.checked).length;
    const total = this.inputs.length;
    if (this.bar) this.bar.style.setProperty('--tm-progress', total ? `${(done / total) * 100}%` : '0%');
    if (this.label) this.label.textContent = `${done} di ${total} completati`;
  }
}

if (!customElements.get('tm-calculator')) customElements.define('tm-calculator', TmCalculator);
if (!customElements.get('tm-checklist')) customElements.define('tm-checklist', TmChecklist);

const items = document.querySelectorAll('[data-tm-reveal]');

if (!('IntersectionObserver' in window)) {
  items.forEach((item) => item.classList.add('is-in'));
} else {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      }
    },
    { threshold: 0.1, rootMargin: '0px 0px -5% 0px' }
  );

  items.forEach((item) => observer.observe(item));
}
